import { render } from "./ActivityHeatmap.vue?vue&type=template&id=006b4b10&scoped=true"
import script from "./ActivityHeatmap.vue?vue&type=script&lang=js"
export * from "./ActivityHeatmap.vue?vue&type=script&lang=js"

import "./ActivityHeatmap.vue?vue&type=style&index=0&id=006b4b10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006b4b10"]])

export default __exports__